export default __webpack_public_path__ + "static/media/mobile-banking.ed767864.svg";